module.exports = __webpack_public_path__ + "img/bm.50c5e390.jpg";